import { z } from "zod";

export const campaignSettingSchema = z.object({
  campaignTitle: z.string().min(1, "Campaign title is required"),
  campaignLanguage: z.string().min(1, "Campaign language is required"),
  /** Legacy / unused in UI; may be string or string[] from API */
  emailDomain: z.union([z.string(), z.array(z.string())]).optional(),
  /** Product/services sold in this campaign (persisted as `campaignService` on save) */
  services: z
    .array(z.string().min(1).max(200))
    .max(25, "Maximum 25 services")
    .optional()
    .default([]),
  notificationEmail: z
    .string()
    .trim()
    .refine((val) => !val || z.string().email().safeParse(val).success, {
      message: "Enter a valid email address",
    })
    .optional()
    .default(""),
});
